import { isArray, map } from 'lodash';

import Err from 'models/err';
import ExternalAppCardTemplate from 'models/external_apps/external_app_card_template';
import IdGenerator from 'scripts/domain/contracts/id_generator';
import InvalidateAppCardData from 'actions/external_apps/invalidate_app_card_data';
import qconsole from 'scripts/lib/qconsole';
import RequestExternalAppCardTemplates from 'actions/external_apps/request_app_card_templates';
import SendActiveAppCardAnalytics from 'actions/external_apps/send_active_app_card_analytics';

export default class ExternalAppCardTemplateGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onFetchSuccess(data) {
    try {
      if (!isArray(data)) {
        throw new Error(`Expected array, got ${typeof data}`);
      }

      const entities = map(data, dto => {
        const { errors, externalAppCardId, template } = dto;
        const errorEntities = map(errors, errDto => new Err(errDto));

        const entityAttrs = {
          id: IdGenerator.newId(),
          externalAppCardId,
          template,
          errors: errorEntities.length ? errorEntities : undefined,
        };
        return ExternalAppCardTemplate.create(entityAttrs);
      });

      this.context.stores.externalAppCardTemplates.set(entities);
      this.context.stores.externalAppCardTemplates.clearErrorForLoading();
      this.context.executeAction(InvalidateAppCardData);
      this.context.executeAction(SendActiveAppCardAnalytics);
    } catch (err) {
      // If we are here, we have received a mangled payload. Report an error
      this.context.errorReporter.reportError(err, {
        extra: { responsePayload: data },
        message: 'ExternalAppCardTemplateGatewayObserver.onFetchSuccess: received invalid response',
      });

      // Set the error flag so that the card(s) know what to do
      this.context.stores.externalAppCardTemplates.setErrorForLoading(
        new Err({
          code: Err.Code.UNEXPECTED_ERROR,
          detail: err.message || err,
        })
      );
    } finally {
      this.context.stores.externalAppCardTemplates.resetLoading();
    }
  }

  onFetchError(error) {
    qconsole.error('Failed to fetch external app UI templates', JSON.stringify(error));

    this.context.stores.externalAppCardTemplates.setErrorForLoading(
      new Err({
        code: Err.Code.UNEXPECTED_ERROR,
        detail: error.message || error,
      })
    );
    this.context.stores.externalAppCardTemplates.resetLoading();
  }

  onBroadcast() {
    this.context.executeAction(RequestExternalAppCardTemplates);
  }

  onBroadcastDelete() {
    this.context.executeAction(RequestExternalAppCardTemplates);
  }
}
